import React from 'react';

interface ErrorIconProps {
  fill?: string;
  width?: string | number;
  height?: string | number;
}

export const ErrorIcon: React.FC<ErrorIconProps> = ({ fill = '#ff4874', width = 16, height = 16 }) => (
  <svg width={width} height={height} viewBox="0 0 16 16" fill="none">
    <path
      d="M8,0 C12.418278,0 16,3.58172204 16,8 C16,12.418278 12.418278,16 8,16 C3.58172204,16 0,12.418278 0,8 C0,3.58172204 3.58172204,0 8,0 Z M8,1.25 C4.27207796,1.25 1.25,4.27207796 1.25,8 C1.25,11.727922 4.27207796,14.75 8,14.75 C11.727922,14.75 14.75,11.727922 14.75,8 C14.75,4.27207796 11.727922,1.25 8,1.25 Z M7.9935,10.78 C8.5655,10.78 9.0335,11.248 9.0335,11.807 C9.0335,12.366 8.5655,12.847 7.9935,12.847 C7.4345,12.847 6.9665,12.366 6.9665,11.807 C6.9665,11.248 7.4345,10.78 7.9935,10.78 Z M8,3 C8.46309076,3 8.8385,3.37540924 8.8385,3.8385 L8.8385,3.8385 L8.8385,8.6615 L8.83196689,8.76667966 C8.78022591,9.18012467 8.4274684,9.5 8,9.5 C7.53690924,9.5 7.1615,9.12459076 7.1615,8.6615 L7.1615,8.6615 L7.1615,3.8385 L7.16803311,3.73332034 C7.21977409,3.31987533 7.5725316,3 8,3 Z"
      fill={fill}
    />
  </svg>
);
